export const GET_MESSAGES_SUCCESS = '[MESSAGING][MESSAGES] get messages succeeded';
export const GET_MESSAGE_DETAILS_SUCCESS = '[MESSAGING][MESSAGE] get message detail succeeded';
export const SELECT_MENU = '[MESSAGING][MENU] select menu';
export const SELECT_MESSAGE = '[MESSAGING][MESSAGE] select message';
export const SELECT_DETAIL_VIEW = '[MESSAGING][DETAIL VIEW] select detail view';
export const GET_COUNTS_SUCCESS = '[MESSAGING][COUNTS] get counts succeeded';

export const APPLY_FILTERS_PENDING = '[MESSAGING][FILTERS] apply filters pending';
export const APPLY_FILTERS_SUCCESS = '[MESSAGING][FILTERS] apply filters success';
export const APPLY_FILTERS_FAILURE = '[MESSAGING][FILTERS] apply filters failure';

export const CLEAR_FILTERS_PENDING = '[MESSAGING][FILTERS] clear filters pending';
export const CLEAR_FILTERS_SUCCESS = '[MESSAGING][FILTERS] clear filters success';
export const CLEAR_FILTERS_FAILURE = '[MESSAGING][FILTERS] clear filters failure';

export const FILTER_MESSAGES = '[MESSAGING][FILTERS] get filtered Messages';
export const SHOW_FILTER_MODAL = '[MESSAGING][FILTERS] toggle Modal';
export const CHANGE_SORT_ORDER = '[MESSAGING][SORTING] change Messages Order';

export const SENDMESSAGE_PENDING = '[MESSAGING][SEND] send message pending';
export const SHOW_NOTIFICATION_SUCCESS = '[MESSAGING][SHOW] show notification success';
export const HIDE_NOTIFICATION_SUCCESS = '[MESSAGING][HIDE] hide notification success';

export const SWITCH_VIEW = '[MESSAGING][VIEW] switch view';

export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const TOGGLE_COMPOSE_DRAWER = 'TOGGLE_COMPOSE_DRAWER';

export const RESET_MENU = '[MESSAGING][RESET] menu reset';

export const ENGAGEMENT_LOAD_PENDING = '[MESSAGING][ENGAGEMENT] load engagemnt filter';
export const ENGAGEMENT_LOAD_SUCCESS = '[MESSAGING][ENGAGEMENT] success engagemnt filter';

export const CHECK_STATUS = '[CHECK][LOGIN] check login status';

export const SET_ATTACHMENTS = '[MESSAGING][ATTACHMENTS] set attachments';
export const RESET_ATTACHMENTS = '[MESSAGING][ATTACHMENTS] reset attachments';
export const DELETE_ATTACHMENT = '[MESSAGING][ATTACHMENTS] delete attachment';
export const RESET_COMPOSE_ID = '[MESSAGING][ATTACHMENTS] reset compose id';
export const RESET_MESSAGE_SHOWN = '[MESSAGING][MESSAGE SHOWN] reset message shown';
export const RESUME_DRAFT_MESSAGE = '[MESSAGING][RESUME] resume draft message';
export const CLEAR_RESUME_DRAFT = '[MESSSAGING][RESUME] clear resume draft';
export const SET_COMPOSE_ID = '[MESSSAGING][ATTACHMENTS] set compose id';

export const RESET_FILTERS = '[MESSAGING][RESET FILTERS] reset filters';
export const SET_FILTERS = '[MESSAGING][SET FILTERS] set filters';

export const REMOVE_MESSAGE_FROM_STATE = '[MESSAGING][REMOVE] remove message from state';

export const EMPTY_INBOX_MESSAGES = '[MESSAGING][EMPTY] empty messaging inbox';

export const STOP_MESSAGING_REQUESTS = '[MESSAGING][EMPTY] stop messaging requests';

export const CLEAR_MESSAGES_AND_COUNTS = '[MESSAGING][EMPTY] clear all messages and counts';

export const GET_FILTERS = '[MESSAGING][FILTERS] get filters success';

export const RESET_FOLDERS = '[MESSAGING][RESET] reset folders';
export const RESET_IS_FILTER_LOADING = '[MESSAGING][RESET FILTER LOADER] reset filter loader';
export const RESET_MESSAGE_LOADING = '[MESSAGING][RESET MESSAGE LOADER] reset message loader';
export const RESET_REFRESH_DASHBOARD_UN_READ_COUNT = '[MESSAGING][RESET_REFRESH_DASHBOARD_UN_READ_COUNT] reset message unread count';
export const GET_PILL_FILTER = '[MESSAGING][GET_PILL_FILTER] get pill filter';
